export default {
	data() {
		return {
			wikidataUrl: process.env.MIX_WIKIDATA_URL,
			mostUsedTags: [],
			recentlyUsedTags: [],
		}
	},
	methods: {
		getMostUsedTags(taggableType) {
			axios.get('/' + taggableType + '/mostUsedTags').then(response => {
				this.mostUsedTags = response.data;
			}).catch(err => {
				console.log(err)
			})
		},
		getRecentlyUsedTags(taggableType) {
			axios.get('/' + taggableType + '/recentlyUsedTags').then(response => {
				this.recentlyUsedTags = response.data;
			}).catch(err => {
				console.log(err)
			})
		},
		// This will live update annotation regions if 'Preview Annotations' is toggled.
		updateAnnotations() {
			this.$store.state.canvases.data.map(canvas => {
				if(this.canvas.id === canvas.id) {
					Vue.set(canvas, 'annotations', this.canvas.annotations);
				}
			});
		},
		updateTags() {
			this.$store.state.canvases.data.map(canvas => {
				if(this.canvas.id === canvas.id) {
					Vue.set(canvas, 'tags', this.canvas.tags);
				}
			});
		},
	}
};